import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy, NgModule, ViewChild, ViewContainerRef, Injector, NgModuleRef, Compiler, LOCALE_ID, Inject } from '@angular/core';

import { Credentials } from '../../shared/models/credentials.interface';
import { finalize } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { User } from '../../shared/models/user.interface';
import { LoginService } from '../services/login.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends AbstractBiditComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  brandNew: boolean;
  submitted: boolean = false;
  credentials: Credentials = { email: '', password: '' };

  showLogin: boolean = true;
  showForgotPassword: boolean = false;

  user: User;

  constructor(deviceDetectorService: DeviceDetectorService,
    @Inject(LOCALE_ID) public locale: string,
    private loginService: LoginService, private router: Router, private activatedRoute: ActivatedRoute) {
    super(deviceDetectorService);
  }  

  ngOnInit() {
    // subscribe to router event
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        this.brandNew = param['brandNew'];
        this.credentials.email = param['email'];
      });

    if (this.loginService.checkIsLoggedIn()) {
      this.router.navigate(['/']);
    }
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();
  }  

  login({ value, valid }: { value: Credentials, valid: boolean }) {
    this.submitted = true;
    this.isRequesting = true;
    this.errors = '';
    if (valid) {
      this.loginService.login(value.email, value.password)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          {
            next: (result) => {
              let user = JSON.parse(result.user);
              let defaultLocale = user.Locale ?? 'en';
              if (defaultLocale == this.locale) {
                this.router.navigate(['/']);
              } else {
                window.location.href = `/${defaultLocale}/index.html`;
              }
            },
            error: (error: string) => {
              console.log(error);
              this.errors = error
            }
          });
    }
  }

  forgotPassword() {
    this.errors = null;
    this.showLogin = false;
    this.showForgotPassword = true;
  }

  returnToLogin() {
    this.errors = null;
    this.showLogin = true;
    this.showForgotPassword = false;
  }

  sendPasswordReset(form: NgForm) {
    if (form.valid) {
      this.isRequesting = true;

      this.loginService.sendResetEmail(form.value.email)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          {
            next: (result) => {
              this.isRequesting = false;
              alert($localize`An email with a link to reset your password has been sent to the email address provided, if the BIDIT account exists in our system`);

              this.showLogin = true;
              this.showForgotPassword = false;
            },
            error: (error: string) => this.errors = error
          });
    }
  }
}
